<template>
    <div id="g4424c" class="u75237">
            <div id="gea9ef" class="u5efe2">
              <div class="botton_left_text">
                <img id="g78166" class="shuidi" style="height: 16px;width: 22px;" src="../../../assets/images/tuoyuan.png"
                  alt="" />
                <div class="text-carousel" @click="gotccsibizinfo('https://www.csibizinfo.com/?Form=Csi')">

                  <!--  @slideChange="onSlideChange" -->
             <swiper :options="swiperOption" class="swiper-container">
                    <swiper-slide>{{ $t('Home.BusinessIntelligence') }} </swiper-slide>
                    <swiper-slide>{{ $t('Home.CompanyIdentityVerification') }} </swiper-slide>
                    <swiper-slide>{{ $t('Home.KYCSolutions') }}</swiper-slide>
                    <swiper-slide>{{ $t('Home.OwnershipPenetration') }}</swiper-slide>
                    <swiper-slide>{{ $t('Home.CompanyFinancialAnalysis') }}</swiper-slide>
                    <swiper-slide>{{ $t('Home.CreditRatings') }}</swiper-slide>
                    <swiper-slide>{{ $t('Home.CreditReports') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.ESGRatings') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.VendorScreening') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.MarketResearch') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.IndustryAnalysis') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.BusinessAnalytics') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.ImportExportData') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.CompanyNews') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.Sanctions') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.SearchLeads') }}</swiper-slide>

                    <swiper-slide>{{ $t('Home.BusinessIntelligence') }} </swiper-slide>
                    <swiper-slide>{{ $t('Home.CompanyIdentityVerification') }} </swiper-slide>
                    <swiper-slide>{{ $t('Home.KYCSolutions') }}</swiper-slide>
                    <swiper-slide>{{ $t('Home.OwnershipPenetration') }}</swiper-slide>
                    <swiper-slide>{{ $t('Home.CompanyFinancialAnalysis') }}</swiper-slide>
                    <swiper-slide>{{ $t('Home.CreditRatings') }}</swiper-slide>
                    <swiper-slide>{{ $t('Home.CreditReports') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.ESGRatings') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.VendorScreening') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.MarketResearch') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.IndustryAnalysis') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.BusinessAnalytics') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.ImportExportData') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.CompanyNews') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.Sanctions') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.SearchLeads') }}</swiper-slide>

                    <swiper-slide>{{ $t('Home.ImportExportData') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.CompanyNews') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.Sanctions') }}
                    </swiper-slide>
                    <swiper-slide>{{ $t('Home.SearchLeads') }}</swiper-slide>
                  </swiper>
                </div>

              </div>


            </div>
         
          </div>
</template>
<script>


export default {

    components: {

    },



    data() {
        return {
            swiperOption: {
                slidesPerView: 10,
                centeredSlides: true,
                //居中幻灯片无缺口。当你通过设置 centeredSlides: true 使得幻灯片居中后，
                centeredSlidesBounds: true,
                normalizeSlideIndex: false,

                direction: 'vertical',
                spaceBetween: 0,
                // 滑动速度
                speed: 800,
                autoplay: { //自动开始
                    delay: 3000, //时间间隔
                    disableOnInteraction: false, //*手动操作轮播图后不会暂停*
                },
                // 无限循环
                loop: true,
                observer: false,
                observeParents: false,
                // 挂载指示点
                // pagination: {
                //   el: '.swiper-pagination',
                //   dynamicBullets: true,
                //   clickable :true
                // },
                // 左右箭头
                // navigation: {
                //   nextEl: '.swiper-button-next',
                //   prevEl: '.swiper-button-prev'
                // }

            },

        };
    },

    methods: {
        gotccsibizinfo(value) {
      window.open(value, '_blank')
    },
    },

    computed: {},
};
</script>
<style scoped>



.u75237 {
    display: flex;
    height: 100%;
}

.u5efe2 {
    width: 100%;
    height: 100%;
    background: #eeeeee;
    border-radius: 0.857rem 0.857rem 0rem 0rem;
    position: relative;
    /* margin-right: 1rem; */
    cursor: pointer;

}

.u326e0 {
    width: 100%;
    height: 100%;
    border-radius: 0.857rem;
}



.botton_left_text {
    background: #1290C9;
    border-radius: 12px 12px;
    height: 100%;
    width: 100%;
    padding-left: 2.428rem;
}

/deep/.swiper-container {
    height: 21.4285714rem;
}

.slide-text {
    text-align: center;
    font-size: 1rem !important;
    color: #666;
    transition: all 0.3s;
}

/deep/ .swiper-slide {
    width: 100% !important;
    text-align: left !important;
    height: 2.14285714rem !important;
    font-size: 1rem !important;
    line-height: 2.14285714rem;
    transition: transform 0.3s, color 0.3s;
    padding-left: 5px;
    color: #F4F4F44D;
    transition: 0.5s ease-in-out !important;
    font-family: "DMSans DMSans";
}

/deep/.swiper-slide-active {
    color: #F4F4F4 !important;
    font-size: 1rem !important;
    font-family: 'DMSans Bold';
}

.shuidi {
    position: relative;
    left: -24px;
    top: 11.46rem;
}


</style>